<template>
	<div>
		<IKHistoricoRelatorio />
	</div>
</template>

<script>
import IKHistoricoRelatorio from '@/components/template/IKHistoricoRelatorio.vue';
export default {
	components: {
        'IKHistoricoRelatorio': IKHistoricoRelatorio,
    }
}
</script>

<style scoped>
</style>